const noAuthObj = {
    'PROF':[
        '视图集',
        '自定义详情页',
        '自定义布局',
        '自定义列表按钮',
        '自定义TAB设置',
        '自定义工作台',
        '自定义首页门户',
        '列表详情',
        '业务组件',
        '数据大屏',
        '代码节点',
        '循环节点',
        '函数调用节点',
        '子流程节点',
        '文件归档',
        '连接器节点',
        '流程分析',
        '流程监控',
        '流程调试',
        '连接器',
        '外部用户',
        '水印',
    ]
}
let verSion = null
let appRef = null
function setCurVersion(ver,that){
    verSion = ver
    appRef = that
}
function checkIsHadAuth(type){
    if(verSion == 'FLAGSHIP'){
        appRef.lowVerDlgVs = false
    }
    else{
        appRef.lowVerDlgVs = noAuthObj[verSion] ?  noAuthObj[verSion].includes(type) : true
    }
}
function noAuth(type){
    if(verSion == 'FLAGSHIP'){
        return false
    }
    else{
        return noAuthObj[verSion] ?  noAuthObj[verSion].includes(type) : true
    }
}
export default {setCurVersion, checkIsHadAuth,noAuth}